import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import classNames from "classnames";
import FormControl from "../FormControl";
import FormGroup from "../FormGroup";
import FormLabel from "../FormLabel";
import useStyles from "./styles";
import ErrorHandlingFormHelperText from "../ErrorHandlingFormHelperText";
export const Range = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    component,
    disabled,
    error,
    errorMessage,
    fromProps,
    toProps,
    id,
    label,
    required,
    value,
    onBlur,
    onChange,
    fullWidth,
    className,
    helperText,
    executeValidation,
    popoverText,
    customHelperIcon,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  const fromId = id ? `${id}-range-from` : undefined;
  const onRangeChange = key => (event, values) => {
    values = values ? values : event.target.value;
    onChange && onChange(event, {
      ...value,
      [key]: values
    });
  };
  const onExecuteValidation = key => value => {
    const currentValue = props;
    executeValidation && executeValidation({
      ...currentValue.value,
      [key]: value
    });
  };
  const isFullWidth = () => {
    return fullWidth || fromProps && fromProps["fullWidth"] || toProps && toProps["fullWidth"];
  };
  const Component = component;
  return /*#__PURE__*/React.createElement(FormControl, _extends({
    fullWidth: isFullWidth(),
    id: id,
    disabled: disabled,
    error: error,
    required: required
  }, otherProps), label && /*#__PURE__*/React.createElement(FormLabel, {
    className: classNames("prmbl-range-label", classes.rangeLabel),
    component: "label",
    id: id,
    htmlFor: fromId,
    disabled: disabled
  }, label), /*#__PURE__*/React.createElement(FormGroup, {
    id: id ? id + "-range-group" : undefined,
    className: classNames("prmbl-range", className, classes.root),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("prmbl-range-component", classes.component, {
      [classes.componentFullWidth]: isFullWidth()
    })
  }, /*#__PURE__*/React.createElement(Component, _extends({
    fullWidth: isFullWidth(),
    id: fromId,
    onChange: onRangeChange("from") // This is meant to be invoked. It is a function returning a function.
    ,
    onBlur: onBlur,
    executeValidation: onExecuteValidation("from"),
    required: required,
    value: value?.from,
    disabled: disabled,
    margin: false
  }, fromProps ?? {}))), /*#__PURE__*/React.createElement("div", {
    className: classNames("prmbl-range-component", classes.component, {
      [classes.componentFullWidth]: isFullWidth()
    })
  }, /*#__PURE__*/React.createElement(Component, _extends({
    fullWidth: isFullWidth(),
    id: id ? `${id}-range-to` : undefined,
    onChange: onRangeChange("to") // This is meant to be invoked. It is a function returning a function.
    ,
    onBlur: onBlur,
    executeValidation: onExecuteValidation("to"),
    required: required,
    value: value?.to,
    disabled: disabled,
    margin: false
  }, toProps ?? {})))), /*#__PURE__*/React.createElement(ErrorHandlingFormHelperText, {
    id: id,
    error: error,
    errorMessage: errorMessage,
    disabled: disabled,
    helperText: helperText,
    popoverText: popoverText,
    customHelperIcon: customHelperIcon
  }));
});
Range.displayName = "Range";
export default Range;